import React from 'react'

const Companies = ({ companySearch, setCompanySearch, searchedCompanies, admin, mutateAdmin, groupedCompanies, groupedRentalCompanies }) => (
  <div>
    <h4>Lägg till företag</h4>
    <input type="text" placeholder="Sök företag" value={companySearch} onChange={(e) => setCompanySearch(e.target.value)} />
    <div className="flex">
      {searchedCompanies.map((c) => (
        <div
          onClick={() => {
            mutateAdmin({ ...admin, companies: admin.companies.concat({ _id: c._id }) })
            setCompanySearch('')
          }}
          style={{ background: '#fff', margin: 2, padding: 2, cursor: 'pointer' }}
          key={c._id}
        >
          {c.name}
        </div>
      ))}
    </div>
    {groupedCompanies
      && groupedRentalCompanies
      && admin.companies.map((c) => {
        const [company] = groupedCompanies.get(c._id) || groupedRentalCompanies.get(c._id) || []
        if (!company) return null

        return (
          <div key={c._id}>
            <span
              onClick={() => {
                mutateAdmin({
                  ...admin,
                  companies: admin.companies.filter((cc) => cc._id !== c._id),
                })
              }}
              style={{ color: 'red', cursor: 'pointer' }}
            >
              X &nbsp;
            </span>
            {company.name}
            <span>&nbsp; - Veckorapporter</span>
            &nbsp;
            <input
              type="checkbox"
              checked={c.shouldSendReportEmails || false}
              onChange={(e) => {
                mutateAdmin({
                  ...admin,
                  companies: admin.companies.reduce((acc, cc) => {
                    if (cc._id !== c._id) return acc.concat(cc)

                    return acc.concat({ _id: c._id, shouldSendReportEmails: e.target.checked })
                  }, []),
                })
              }}
            />
          </div>
        )
      })}
  </div>
)

export default Companies
